module.exports = __webpack_public_path__ + "static/media/Decisions_Step4_Image18.15c35a80.webp";